import {
  LOADING_POST_ACTIONS,
  FETCH_POST_ACTIONS_FAILED,
  FETCH_POST_ACTIONS_SUCCESS,
  VERIFY_ADMIN_ACTION,
} from './postActions.actions'

import {
  EXISTING_USER_AUTHENTICATED,
  NEW_USER_AUTHENTICATED,
  USER_LOGOUT,
} from '../currentUser/currentUser.actions'

const INITIAL_STATE = {
  isLoading: false,
  hasErrors: false,
  optionsList: [],
}

export const postActionsReducer = (state = INITIAL_STATE, { type, newState }) => {
  switch (type) {
    case LOADING_POST_ACTIONS:
      return { ...state, ...newState }
    case FETCH_POST_ACTIONS_FAILED:
      return { ...state, ...newState }
    case FETCH_POST_ACTIONS_SUCCESS:
      return { ...state, ...newState }
    case USER_LOGOUT:
      return { ...state, optionsList: [] }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/postActions/postActions.reducers.js